import { supabase } from '@/lib/supabase/client';

// Scheduled live chat sessions (table LiveEvent, public read). The next one that hasn't ended yet
// drives the banner on /live and the card on the feed.
export interface LiveEvent {
  id: string;
  title: string;
  description: string | null;
  symbol: string | null;
  hostUsername: string | null;
  startsAt: string;
  endsAt: string;
}

export async function fetchNextLiveEvent(): Promise<LiveEvent | null> {
  const { data, error } = await supabase
    .from('LiveEvent')
    .select('id, title, description, symbol, hostUsername, startsAt, endsAt')
    .gt('endsAt', new Date().toISOString())
    .order('startsAt', { ascending: true })
    .limit(1)
    .maybeSingle();
  if (error) return null;
  return (data as LiveEvent | null) ?? null;
}

/** "Uživo sada" / "Danas u 20:00" / "Sutra u 20:00" / "Pon 7. sep u 20:00" (Belgrade time). */
export function describeEventTime(ev: LiveEvent, lang: 'sr' | 'en', now = Date.now()): { label: string; live: boolean; startsInMs: number } {
  const start = Date.parse(ev.startsAt), end = Date.parse(ev.endsAt);
  const tz = 'Europe/Belgrade';
  const time = new Intl.DateTimeFormat('sr-Latn-RS', { hour: '2-digit', minute: '2-digit', timeZone: tz, hour12: false }).format(new Date(start));
  if (now >= start && now < end) return { label: lang === 'sr' ? 'Uživo sada' : 'Live now', live: true, startsInMs: 0 };
  const dayOf = (ms: number) => new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(ms));
  const today = dayOf(now), eventDay = dayOf(start), tomorrow = dayOf(now + 864e5);
  let when: string;
  if (eventDay === today) when = lang === 'sr' ? 'Danas' : 'Today';
  else if (eventDay === tomorrow) when = lang === 'sr' ? 'Sutra' : 'Tomorrow';
  else when = new Intl.DateTimeFormat(lang === 'sr' ? 'sr-Latn-RS' : 'en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: tz }).format(new Date(start));
  return { label: `${when} ${lang === 'sr' ? 'u' : 'at'} ${time}`, live: false, startsInMs: start - now };
}
